<template>
    <div>
        <!-- Scroll horizontal cuando la tabla no cabe; los menús de BaseDropdown se montan en <body>, así que no se recortan -->
        <div v-auto-hide-scrollbar class="tw:overflow-x-auto tw:rounded-3xl">
            <!-- tw:overflow-x-auto tw:scrollbar-autohide -->
            <table
                class="tw:w-full tw:text-xs tw:text-left tw:border tw:border-slate-100 tw:[&_th]:whitespace-nowrap tw:[&_td]:relative tw:[&_tbody_tr]:transition-colors tw:[&_tbody_tr:hover]:bg-slate-100/50"
                :class="tableSizeClass">
                <thead
                    class="tw:bg-slate-200/70 tw:border-b tw:border-slate-200 tw:text-slate-600 tw:uppercase tw:tracking-wider">
                    <slot name="header"></slot>
                </thead>
                <tbody class="tw:divide-y tw:divide-slate-200 tw:text-slate-600">
                    <slot name="body"></slot>
                </tbody>
            </table>
        </div>
        <div v-if="$slots.footer"
            class="tw:p-3 tw:sm:p-4 tw:border-t tw:border-slate-200 tw:flex tw:justify-center tw:items-center">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
// Padding de celdas por tamaño de tabla
const SIZE_CLASSES = {
    compact: 'tw:[&_th]:px-3 tw:[&_th]:py-2 tw:[&_td]:px-3 tw:[&_td]:py-2',
    normal: 'tw:[&_th]:px-5 tw:[&_th]:py-3.5 tw:[&_td]:px-5 tw:[&_td]:py-4',
    large: 'tw:[&_th]:px-6 tw:[&_th]:py-5 tw:[&_td]:px-6 tw:[&_td]:py-5',
};

export default {
    name: 'BaseTable',
    props: {
        // Define el tamaño de la tabla: 'compact', 'normal' o 'large'
        size: {
            type: String,
            default: 'normal',
            validator: (value) => ['compact', 'normal', 'large'].includes(value)
        }
    },
    computed: {
        tableSizeClass() {
            return SIZE_CLASSES[this.size] || SIZE_CLASSES.normal;
        }
    }
}
</script>
